import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { MusicIcon, BookOpenIcon, GlobeIcon, CameraIcon, UsersIcon, HeartIcon, TrophyIcon, Atom } from 'lucide-react';
const ClubsAndSocieties = () => {
  const clubs = [{
    id: 1,
    name: 'Science & Technology Club',
    description: 'For students passionate about science and technology. Activities include experiments, robotics, coding, and preparation for science competitions.',
    image: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1780&q=80',
    meetingDay: 'Tuesdays',
    advisor: 'Mr. Olatunji',
    icon: <Atom className="h-6 w-6 text-blue-700" data-id="element-4116" />,
    achievements: ['1st Place in Regional Science Fair 2023', 'National Robotics Competition Finalists 2022', 'Innovation Award at State STEM Challenge']
  }, {
    id: 2,
    name: 'Literary & Debating Society',
    description: 'Focuses on developing public speaking, critical thinking, and argumentation skills. Members participate in debates, public speaking contests, and model UN conferences.',
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    meetingDay: 'Wednesdays',
    advisor: 'Mrs. Adeyemi',
    icon: <BookOpenIcon className="h-6 w-6 text-blue-700" data-id="element-4117" />,
    achievements: ['Champions, State Debating Competition 2023', 'Best Speaker Award at National Schools Debate', '2nd Place, Model United Nations Conference']
  }, {
    id: 3,
    name: 'Art & Photography Club',
    description: 'For creative students interested in visual arts. Activities include drawing, painting, sculpture, photography, and organizing art exhibitions.',
    image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1742&q=80',
    meetingDay: 'Thursdays',
    advisor: 'Mr. Johnson',
    icon: <CameraIcon className="h-6 w-6 text-blue-700" data-id="element-4118" />,
    achievements: ['Best School Art Exhibition Award 2023', 'Multiple Winners in National Youth Art Competition', "Published Photography Book 'Campus Life'"]
  }, {
    id: 4,
    name: 'Music & Drama Club',
    description: 'For students interested in performing arts. Members learn to play instruments, sing, act, and participate in school productions and competitions.',
    image: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    meetingDay: 'Fridays',
    advisor: 'Mrs. Okafor',
    icon: <MusicIcon className="h-6 w-6 text-blue-700" data-id="element-4119" />,
    achievements: ['Best School Drama Production 2023', 'Winners, State Choir Competition', 'Selected for National Youth Orchestra']
  }, {
    id: 5,
    name: 'Environmental Club',
    description: 'Focuses on environmental conservation and sustainability. Activities include tree planting, recycling initiatives, and awareness campaigns.',
    image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1706&q=80',
    meetingDay: 'Mondays',
    advisor: 'Dr. Nwachukwu',
    icon: <GlobeIcon className="h-6 w-6 text-blue-700" data-id="element-4120" />,
    achievements: ['School Recycling Program Implementation', 'Community Garden Project', 'Environmental Awareness Campaign Award']
  }, {
    id: 6,
    name: 'Sports Club',
    description: 'Promotes physical fitness, teamwork, and sportsmanship through various sports activities and competitions.',
    image: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1829&q=80',
    meetingDay: 'Tuesdays & Thursdays',
    advisor: 'Mr. Adebayo',
    icon: <TrophyIcon className="h-6 w-6 text-blue-700" data-id="element-4121" />,
    achievements: ['State Football Champions 2023', 'Regional Athletics Meet: 5 Gold Medals', 'National Basketball Tournament Finalists']
  }, {
    id: 7,
    name: 'Community Service Club',
    description: 'Engages in volunteer work and community development projects to instill social responsibility and empathy.',
    image: 'https://images.unsplash.com/photo-1593113630400-ea4288922497?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    meetingDay: 'Wednesdays',
    advisor: 'Mrs. Ogunleye',
    icon: <HeartIcon className="h-6 w-6 text-blue-700" data-id="element-4122" />,
    achievements: ['Orphanage Support Program', 'Annual Charity Fundraiser (₦2M raised)', 'Community Literacy Program Award']
  }, {
    id: 8,
    name: 'Cultural Diversity Club',
    description: 'Celebrates cultural diversity and promotes understanding and appreciation of different cultures and traditions.',
    image: 'https://images.unsplash.com/photo-1607453998774-d533f65dac99?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1624&q=80',
    meetingDay: 'Fridays',
    advisor: 'Mr. Oluseyi',
    icon: <UsersIcon className="h-6 w-6 text-blue-700" data-id="element-4123" />,
    achievements: ['Best Cultural Festival Organization', 'International Exchange Program Coordination', 'Cultural Diversity Awareness Campaign']
  }];
  const [selectedClub, setSelectedClub] = useState<number | null>(null);
  const handleClubClick = (id: number) => {
    setSelectedClub(selectedClub === id ? null : id);
  };
  return <div className="min-h-screen bg-white" data-id="element-4124">
      <PageHeader title="Clubs & Societies" description="Explore the diverse range of extracurricular activities available to students at Isonyin Grammar School." backgroundImage="https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Student Life',
      path: '/student-life'
    }, {
      label: 'Clubs & Societies',
      path: '/student-life/clubs'
    }]} data-id="element-4125" />
      <div className="container mx-auto px-4 py-12" data-id="element-4126">
        <div className="text-center mb-10" data-id="element-4127">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-4128">
            Discover Our Clubs & Societies
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-4129"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-4130">
            Our clubs and societies provide platforms for students to explore
            their interests, develop skills, and build relationships outside the
            classroom. Each club is supervised by a staff advisor who provides
            guidance and support.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-4131">
          {clubs.map(club => <div key={club.id} className={`bg-white rounded-lg shadow-md overflow-hidden transform transition-all duration-300 ${selectedClub === club.id ? 'scale-105 shadow-lg' : 'hover:shadow-lg'}`} data-id="element-4132">
              <div className="relative h-48 overflow-hidden" data-id="element-4133">
                <img src={club.image} alt={club.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-4134" />
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black/60 to-transparent flex items-end p-4" data-id="element-4135">
                  <h3 className="text-xl font-bold text-white" data-id="element-4136">{club.name}</h3>
                </div>
              </div>
              <div className="p-6" data-id="element-4137">
                <div className="flex items-center mb-4" data-id="element-4138">
                  <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-4139">
                    {club.icon}
                  </div>
                  <div data-id="element-4140">
                    <p className="text-sm text-gray-500" data-id="element-4141">Meeting Day</p>
                    <p className="font-medium" data-id="element-4142">{club.meetingDay}</p>
                  </div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-4143">{club.description}</p>
                <Button onClick={() => handleClubClick(club.id)} variant="outline" size="sm" className="w-full" data-id="element-4144">
                  {selectedClub === club.id ? 'Hide Details' : 'Learn More'}
                </Button>
                {selectedClub === club.id && <div className="mt-4 pt-4 border-t border-gray-200 animate-fadeIn" data-id="element-4145">
                    <p className="text-sm text-gray-500 mb-1" data-id="element-4146">Club Advisor</p>
                    <p className="font-medium text-gray-900 mb-3" data-id="element-4147">
                      {club.advisor}
                    </p>
                    <p className="text-sm text-gray-500 mb-2" data-id="element-4148">
                      Notable Achievements
                    </p>
                    <ul className="space-y-1 text-gray-700" data-id="element-4149">
                      {club.achievements.map((achievement, index) => <li key={index} className="flex items-start" data-id="element-4150">
                          <div className="text-yellow-500 mr-2" data-id="element-4151">•</div>
                          <p data-id="element-4152">{achievement}</p>
                        </li>)}
                    </ul>
                    <Button onClick={() => alert(`You've signed up for the ${club.name}! The club advisor will contact you with more information.`)} variant="primary" size="sm" className="w-full mt-4" data-id="element-4153">
                      Join This Club
                    </Button>
                  </div>}
              </div>
            </div>)}
        </div>
        <div className="bg-blue-50 p-8 rounded-lg border border-blue-100" data-id="element-4154">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-4155">
            <div data-id="element-4156">
              <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-4157">
                Start Your Own Club
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-4158">
                Don't see a club that matches your interests? You can propose a
                new club or society at Isonyin Grammar School.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-4159">
                To start a new club, you'll need:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-4160">
                <li className="flex items-start" data-id="element-4161">
                  <div className="text-blue-700 mr-2" data-id="element-4162">•</div>
                  <p data-id="element-4163">At least 10 interested students</p>
                </li>
                <li className="flex items-start" data-id="element-4164">
                  <div className="text-blue-700 mr-2" data-id="element-4165">•</div>
                  <p data-id="element-4166">A staff member willing to serve as advisor</p>
                </li>
                <li className="flex items-start" data-id="element-4167">
                  <div className="text-blue-700 mr-2" data-id="element-4168">•</div>
                  <p data-id="element-4169">A clear mission statement and goals</p>
                </li>
                <li className="flex items-start" data-id="element-4170">
                  <div className="text-blue-700 mr-2" data-id="element-4171">•</div>
                  <p data-id="element-4172">A basic plan for club activities</p>
                </li>
              </ul>
              <Button onClick={() => alert('Club proposal form would open here')} variant="secondary" data-id="element-4173">
                Propose a New Club
              </Button>
            </div>
            <div data-id="element-4174">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-4175">
                <h4 className="text-xl font-bold text-blue-900 mb-4" data-id="element-4176">
                  Club Fair
                </h4>
                <p className="text-gray-700 mb-4" data-id="element-4177">
                  Join us at the beginning of each academic year for our Club
                  Fair, where you can learn more about all clubs and societies
                  and sign up for those that interest you.
                </p>
                <div className="bg-yellow-100 p-4 rounded-lg border border-yellow-200 mb-4" data-id="element-4178">
                  <p className="text-gray-800 font-medium" data-id="element-4179">Next Club Fair</p>
                  <p className="text-gray-700" data-id="element-4180">
                    October 15, 2023 | 10:00 AM - 2:00 PM
                  </p>
                  <p className="text-gray-700" data-id="element-4181">School Hall</p>
                </div>
                <Button onClick={() => alert('You will receive a reminder about the Club Fair!')} variant="outline" size="sm" data-id="element-4182">
                  Remind Me
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ClubsAndSocieties;